import { controlDefaults } from '../../../core/form/lib/validateForm';

export const controls = {
  id: {
    ...controlDefaults,
    name: 'id',
    type: 'hidden',
  },
  name:{
    ...controlDefaults,
    placeholder: '',
    name: 'name',
    type: 'text',
    caption: 'Client Name',
    description: 'Required Field',
    validationRules: {
      isRequired: true
    },
  },
  default_masquerade_user_id: {
    ...controlDefaults,
    name: 'default_masquerade_user_id',
    type: 'select',
    caption: 'Default Masquerade User',
    disabled: false,
    options: [],
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
  },
  crm_url:{
    ...controlDefaults,
    placeholder: '',
    name: 'crm_url',
    type: 'text',
    isUrl: true,
    caption: 'Salesforce Attendee URL',
    validationRules: {
      isRequired: false
    },
  },
  default_property_id:{
    ...controlDefaults,
    placeholder: '',
    name: 'default_property_id',
    type: 'select',
    isUrl: true,
    validationRules: {
      isRequired: false
    },
  },
  allow_org_transactions:{
    ...controlDefaults,
    placeholder: '',
    name: 'allow_org_transactions',
    type: 'switch',
    switchLabel: { enabled: 'Yes', disabled: 'No' },
    validationRules: {
      isRequired: false
    },
  }
};
